export * from "./regular-post-drawer.client";
